// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  IAccount,
  IAccountMaintUpdateResult,
  IAddVaultedAccountRequest,
  IAddVaultedAccountResponse,
  IAssetDetailsResponse,
  ICreateTokenRequest,
  IErrorDto,
  IGenericErrorDto,
  IToken,
  ITokenizeAccountRequest,
} from '../models/index';
import {
    IAccountFromJSON,
    IAccountToJSON,
    IAccountMaintUpdateResultFromJSON,
    IAccountMaintUpdateResultToJSON,
    IAddVaultedAccountRequestFromJSON,
    IAddVaultedAccountRequestToJSON,
    IAddVaultedAccountResponseFromJSON,
    IAddVaultedAccountResponseToJSON,
    IAssetDetailsResponseFromJSON,
    IAssetDetailsResponseToJSON,
    ICreateTokenRequestFromJSON,
    ICreateTokenRequestToJSON,
    IErrorDtoFromJSON,
    IErrorDtoToJSON,
    IGenericErrorDtoFromJSON,
    IGenericErrorDtoToJSON,
    ITokenFromJSON,
    ITokenToJSON,
    ITokenizeAccountRequestFromJSON,
    ITokenizeAccountRequestToJSON,
} from '../models/index';

export interface ActivateCardRequest {
    alternateAccountId?: string;
    tokenCardId?: string;
    memberSequenceIdentifier?: number;
}

export interface AddVaultedAccountRequest {
    merchantCustomerId: string;
    fiservAccessToken: string;
    iAddVaultedAccountRequest: IAddVaultedAccountRequest;
}

export interface CreateSecurityAccessTokenRequest {
    iCreateTokenRequest: ICreateTokenRequest;
}

export interface GetAssetDetailsRequest {
    assetId: string;
    correlationId: string;
}

export interface TokenizeAccountRequest {
    tokenId: string;
    iTokenizeAccountRequest: ITokenizeAccountRequest;
}

/**
 * FiservProxyApiServiceServiceApi - interface
 * 
 * @export
 * @interface FiservProxyApiServiceServiceApiInterface
 */
export interface FiservProxyApiServiceServiceApiInterface {
    /**
     * Activates card by token or AAID and member sequence id
     * @summary Activate card
     * @param {string} [alternateAccountId] 
     * @param {string} [tokenCardId] 
     * @param {number} [memberSequenceIdentifier] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FiservProxyApiServiceServiceApiInterface
     */
    activateCardRaw(requestParameters: ActivateCardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IAccountMaintUpdateResult>>;

    /**
     * Activates card by token or AAID and member sequence id
     * Activate card
     */
    activateCard(requestParameters: ActivateCardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IAccountMaintUpdateResult>;

    /**
     * 
     * @summary Add vaulted account to recipient
     * @param {string} merchantCustomerId Represents the Participants ID in the Fiserv Digital Disbursements system
     * @param {string} fiservAccessToken Generated Token ID
     * @param {IAddVaultedAccountRequest} iAddVaultedAccountRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FiservProxyApiServiceServiceApiInterface
     */
    addVaultedAccountRaw(requestParameters: AddVaultedAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IAddVaultedAccountResponse>>;

    /**
     * Add vaulted account to recipient
     */
    addVaultedAccount(requestParameters: AddVaultedAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IAddVaultedAccountResponse>;

    /**
     * For service calls directly from a mobile or connected device, the client needs to have an access token which is received by the client\'s server. Underlying Fiserv API docs (/v1/tokens): https://firstdatanp-ucomgateway.apigee.io/apis/ucomsecurityservices/index 
     * @summary Create a security access token
     * @param {ICreateTokenRequest} iCreateTokenRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FiservProxyApiServiceServiceApiInterface
     */
    createSecurityAccessTokenRaw(requestParameters: CreateSecurityAccessTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IToken>>;

    /**
     * For service calls directly from a mobile or connected device, the client needs to have an access token which is received by the client\'s server. Underlying Fiserv API docs (/v1/tokens): https://firstdatanp-ucomgateway.apigee.io/apis/ucomsecurityservices/index 
     * Create a security access token
     */
    createSecurityAccessToken(requestParameters: CreateSecurityAccessTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IToken>;

    /**
     * The API will retrieve the logo or button image of On Device Wallets, Eligible On File Wallets, and Existing On File Wallets that have been enabled for a given assetId. Underlying Fiserv API docs (/idi/v1/assetDetails): https://developer.fiserv.com/product/IssuerSolutions/api/?type=post&path=/idi/v1/assetDetails 
     * @summary Asset Details API
     * @param {string} assetId 
     * @param {string} correlationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FiservProxyApiServiceServiceApiInterface
     */
    getAssetDetailsRaw(requestParameters: GetAssetDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IAssetDetailsResponse>>;

    /**
     * The API will retrieve the logo or button image of On Device Wallets, Eligible On File Wallets, and Existing On File Wallets that have been enabled for a given assetId. Underlying Fiserv API docs (/idi/v1/assetDetails): https://developer.fiserv.com/product/IssuerSolutions/api/?type=post&path=/idi/v1/assetDetails 
     * Asset Details API
     */
    getAssetDetails(requestParameters: GetAssetDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IAssetDetailsResponse>;

    /**
     * Tokenize an account without an associated uCom customer identifier. The token will be generated by the system configured in the merchants setup. Underlying Fiserv API docs (/v1/account-tokens): https://firstdatanp-ucomgateway.apigee.io/apis/ucomaccountservices/index 
     * @summary Tokenize an account
     * @param {string} tokenId Generated Token ID
     * @param {ITokenizeAccountRequest} iTokenizeAccountRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FiservProxyApiServiceServiceApiInterface
     */
    tokenizeAccountRaw(requestParameters: TokenizeAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IAccount>>;

    /**
     * Tokenize an account without an associated uCom customer identifier. The token will be generated by the system configured in the merchants setup. Underlying Fiserv API docs (/v1/account-tokens): https://firstdatanp-ucomgateway.apigee.io/apis/ucomaccountservices/index 
     * Tokenize an account
     */
    tokenizeAccount(requestParameters: TokenizeAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IAccount>;

}

/**
 * 
 */
export class FiservProxyApiServiceServiceApi extends runtime.BaseAPI implements FiservProxyApiServiceServiceApiInterface {

    /**
     * Activates card by token or AAID and member sequence id
     * Activate card
     */
    async activateCardRaw(requestParameters: ActivateCardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IAccountMaintUpdateResult>> {
        const queryParameters: any = {};

        if (requestParameters['alternateAccountId'] != null) {
            queryParameters['alternate_account_id'] = requestParameters['alternateAccountId'];
        }

        if (requestParameters['tokenCardId'] != null) {
            queryParameters['token_card_id'] = requestParameters['tokenCardId'];
        }

        if (requestParameters['memberSequenceIdentifier'] != null) {
            queryParameters['member_sequence_identifier'] = requestParameters['memberSequenceIdentifier'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/maintenance/card`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IAccountMaintUpdateResultFromJSON(jsonValue));
    }

    /**
     * Activates card by token or AAID and member sequence id
     * Activate card
     */
    async activateCard(requestParameters: ActivateCardRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IAccountMaintUpdateResult> {
        const response = await this.activateCardRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Add vaulted account to recipient
     */
    async addVaultedAccountRaw(requestParameters: AddVaultedAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IAddVaultedAccountResponse>> {
        if (requestParameters['merchantCustomerId'] == null) {
            throw new runtime.RequiredError(
                'merchantCustomerId',
                'Required parameter "merchantCustomerId" was null or undefined when calling addVaultedAccount().'
            );
        }

        if (requestParameters['fiservAccessToken'] == null) {
            throw new runtime.RequiredError(
                'fiservAccessToken',
                'Required parameter "fiservAccessToken" was null or undefined when calling addVaultedAccount().'
            );
        }

        if (requestParameters['iAddVaultedAccountRequest'] == null) {
            throw new runtime.RequiredError(
                'iAddVaultedAccountRequest',
                'Required parameter "iAddVaultedAccountRequest" was null or undefined when calling addVaultedAccount().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['fiservAccessToken'] != null) {
            headerParameters['Fiserv-Access-Token'] = String(requestParameters['fiservAccessToken']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/recipients/{merchantCustomerId}/accounts`;
        urlPath = urlPath.replace(`{${"merchantCustomerId"}}`, encodeURIComponent(String(requestParameters['merchantCustomerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IAddVaultedAccountRequestToJSON(requestParameters['iAddVaultedAccountRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IAddVaultedAccountResponseFromJSON(jsonValue));
    }

    /**
     * Add vaulted account to recipient
     */
    async addVaultedAccount(requestParameters: AddVaultedAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IAddVaultedAccountResponse> {
        const response = await this.addVaultedAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * For service calls directly from a mobile or connected device, the client needs to have an access token which is received by the client\'s server. Underlying Fiserv API docs (/v1/tokens): https://firstdatanp-ucomgateway.apigee.io/apis/ucomsecurityservices/index 
     * Create a security access token
     */
    async createSecurityAccessTokenRaw(requestParameters: CreateSecurityAccessTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IToken>> {
        if (requestParameters['iCreateTokenRequest'] == null) {
            throw new runtime.RequiredError(
                'iCreateTokenRequest',
                'Required parameter "iCreateTokenRequest" was null or undefined when calling createSecurityAccessToken().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/tokens`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ICreateTokenRequestToJSON(requestParameters['iCreateTokenRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ITokenFromJSON(jsonValue));
    }

    /**
     * For service calls directly from a mobile or connected device, the client needs to have an access token which is received by the client\'s server. Underlying Fiserv API docs (/v1/tokens): https://firstdatanp-ucomgateway.apigee.io/apis/ucomsecurityservices/index 
     * Create a security access token
     */
    async createSecurityAccessToken(requestParameters: CreateSecurityAccessTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IToken> {
        const response = await this.createSecurityAccessTokenRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * The API will retrieve the logo or button image of On Device Wallets, Eligible On File Wallets, and Existing On File Wallets that have been enabled for a given assetId. Underlying Fiserv API docs (/idi/v1/assetDetails): https://developer.fiserv.com/product/IssuerSolutions/api/?type=post&path=/idi/v1/assetDetails 
     * Asset Details API
     */
    async getAssetDetailsRaw(requestParameters: GetAssetDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IAssetDetailsResponse>> {
        if (requestParameters['assetId'] == null) {
            throw new runtime.RequiredError(
                'assetId',
                'Required parameter "assetId" was null or undefined when calling getAssetDetails().'
            );
        }

        if (requestParameters['correlationId'] == null) {
            throw new runtime.RequiredError(
                'correlationId',
                'Required parameter "correlationId" was null or undefined when calling getAssetDetails().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/idi/asset-details/{asset-id}/{correlation-id}`;
        urlPath = urlPath.replace(`{${"asset-id"}}`, encodeURIComponent(String(requestParameters['assetId'])));
        urlPath = urlPath.replace(`{${"correlation-id"}}`, encodeURIComponent(String(requestParameters['correlationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IAssetDetailsResponseFromJSON(jsonValue));
    }

    /**
     * The API will retrieve the logo or button image of On Device Wallets, Eligible On File Wallets, and Existing On File Wallets that have been enabled for a given assetId. Underlying Fiserv API docs (/idi/v1/assetDetails): https://developer.fiserv.com/product/IssuerSolutions/api/?type=post&path=/idi/v1/assetDetails 
     * Asset Details API
     */
    async getAssetDetails(requestParameters: GetAssetDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IAssetDetailsResponse> {
        const response = await this.getAssetDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Tokenize an account without an associated uCom customer identifier. The token will be generated by the system configured in the merchants setup. Underlying Fiserv API docs (/v1/account-tokens): https://firstdatanp-ucomgateway.apigee.io/apis/ucomaccountservices/index 
     * Tokenize an account
     */
    async tokenizeAccountRaw(requestParameters: TokenizeAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IAccount>> {
        if (requestParameters['tokenId'] == null) {
            throw new runtime.RequiredError(
                'tokenId',
                'Required parameter "tokenId" was null or undefined when calling tokenizeAccount().'
            );
        }

        if (requestParameters['iTokenizeAccountRequest'] == null) {
            throw new runtime.RequiredError(
                'iTokenizeAccountRequest',
                'Required parameter "iTokenizeAccountRequest" was null or undefined when calling tokenizeAccount().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['tokenId'] != null) {
            headerParameters['Token-Id'] = String(requestParameters['tokenId']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/account-tokens`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ITokenizeAccountRequestToJSON(requestParameters['iTokenizeAccountRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IAccountFromJSON(jsonValue));
    }

    /**
     * Tokenize an account without an associated uCom customer identifier. The token will be generated by the system configured in the merchants setup. Underlying Fiserv API docs (/v1/account-tokens): https://firstdatanp-ucomgateway.apigee.io/apis/ucomaccountservices/index 
     * Tokenize an account
     */
    async tokenizeAccount(requestParameters: TokenizeAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IAccount> {
        const response = await this.tokenizeAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
